import { render, staticRenderFns } from "./PlaybackVideoFlv.vue?vue&type=template&id=20b3f856&scoped=true&"
import script from "./PlaybackVideoFlv.vue?vue&type=script&lang=js&"
export * from "./PlaybackVideoFlv.vue?vue&type=script&lang=js&"
import style0 from "./PlaybackVideoFlv.vue?vue&type=style&index=0&id=20b3f856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3f856",
  null
  
)

export default component.exports